import React, { memo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useInfiniteScroll from "jd-library/useInfiniteScroll";
import { productInventoryFetchComplete } from "../../../actions/productInventory";
import { ALL_INVENTORY_PRODUCTS, LOW_INVENTORY_PRODUCTS, OUT_OF_STOCK_INVENTORY } from "../../../actions/types";
import ShimmerLoader from "../ShimmerLoader";
import NoProductFound from "../../../common/no-product-found/NoProductFound";
import ProductLists from "../product-listing/ProductLists";
import { getProductInventoryApi } from '../productrinventory.common.utils';
import { ProductInventoryTabs } from "../productinventory.constants";
import styles from './styles/product-types.scss';

export const AllProductInventory = memo((props) => {
  const {
    is_Fetching,
    data,
  } = useSelector((state) => state.productInventory.allProducts);
  const { token } = props;
  const dispatch = useDispatch();
  const [isFetchingData, setIsFetchingData] = useState(() => false);

  const loadDataOnScroll=() => {
    if (data?.lastPage === false) {
      const params = {
        pageNo: data?.currentPage + 1,
        action: 'listing',
        'all-products': true,
        inventory: true,
        token
      }
      setIsFetchingData(() => true);
      getProductInventoryApi(params).then((values) => {
        const vals = ({ ...values, products: [...data.products, ...values.products] });
        dispatch(productInventoryFetchComplete(ALL_INVENTORY_PRODUCTS, vals))
        setIsFetching(false);
      }).finally(() => setIsFetchingData(() => false))
    }
    else{
      setIsFetching(false);
    }
  }
  const [isFetching, setIsFetching] = useInfiniteScroll({
    loadMoreCB: loadDataOnScroll,
    useWindow: true,
    threshold: 300,
  });
  if (is_Fetching || !data) {
    return <ShimmerLoader />
  }

  return (
    <div className={styles['product-type-container']}>
      {data?.products?.length === 0 ? <NoProductFound label="No Item Present" /> :
        data?.products?.map((l, i) => {
          return <ProductLists item={l} key={i + 10} type={ProductInventoryTabs.allProducts} loggedIn={props.loggedIn} />
        })
      }
      {isFetchingData &&
        <p>Fetching...</p>
      }
    </div>
  )
})

export const LowInventoryProducts = memo((props) => {
  const {
    is_Fetching,
    data,
  } = useSelector((state) => state.productInventory.lowInventory);
  const { token } = props;
  const dispatch = useDispatch();
  const [isFetchingData, setIsFetchingData] = useState(() => false);

  const [isFetching, setIsFetching] = useInfiniteScroll({
    // scrollContainer: containerRef,
    loadMoreCB: () => {
      if (data?.lastPage === false) {
        const params = {
          pageNo: data?.currentPage + 1,
          action: 'listing',
          'low-inventory': true,
          inventory: true,
          token
        }
        setIsFetchingData(() => true);
        getProductInventoryApi(params).then((values) => {
          const vals = ({ ...values, products: [...data.products, ...values.products] });
          dispatch(productInventoryFetchComplete(LOW_INVENTORY_PRODUCTS, vals))
          setIsFetching(false);
        }).finally(() => setIsFetchingData(() => false))
      }
      else{
        setIsFetching(false);
      }
    },
    useWindow: true,
    threshold: 300,
  });

  if (is_Fetching || !data) {
    return <ShimmerLoader />
  }

  return (
    <div className={styles['product-type-container']}>
      {data?.products?.length === 0 ? <NoProductFound label="No Item Present" /> :
        data?.products?.map((l, i) => {
          return <ProductLists item={l} key={i + 10} type={ProductInventoryTabs.allProducts} loggedIn={props.loggedIn} />
        })
      }
      {isFetchingData &&
        <p>Fetching...</p>
      }
    </div>
  )
})

export const OutOfStockInventory = memo((props) => {
  const {
    is_Fetching,
    data,
  } = useSelector((state) => state.productInventory.outOfStock);
  const { token } = props;
  const dispatch = useDispatch();
  const [isFetchingData, setIsFetchingData] = useState(() => false);

  const [isFetching, setIsFetching] = useInfiniteScroll({
    loadMoreCB: () => {
      if (data?.lastPage === false) {
        const params = {
          pageNo: data?.currentPage + 1,
          action: 'listing',
          'out-of-stock': true,
          inventory: true,
          token
        }
        setIsFetchingData(() => true)
        getProductInventoryApi(params).then((values) => {
          const vals = ({ ...values, products: [...data.products, ...values.products] });
          dispatch(productInventoryFetchComplete(OUT_OF_STOCK_INVENTORY, vals))
          setIsFetching(false);
        }).finally(() => setIsFetchingData(() => false));
      } else{
        setIsFetching(false);
      }
    },
    useWindow: true,
    threshold: 300,
  });

  if (is_Fetching || !data) {
    return <ShimmerLoader />
  }

  return (
    <div className={styles['product-type-container']}>
      {data?.products?.length === 0 ? <NoProductFound label="No Item Present" /> :
        data?.products?.map((l, i) => {
          return <ProductLists item={l} key={i + 10} type={ProductInventoryTabs.allProducts} loggedIn={props.loggedIn} />
        })
      }
      {isFetchingData &&
        <p>Fetching...</p>
      }
    </div>
  )
})